import React from 'react';
import { useTranslation } from 'react-i18next';

const FaqPage = ({ onButtonClick, onBack }) => {
  const { t } = useTranslation();
  
  // Полный массив со всеми 14 вопросами
  const faqData = [
    {
      question: t('faqPage.questions.nonResident'),
      answer: t('faqPage.answers.nonResident')
    },
    {
      question: t('faqPage.questions.workingHours'),
      answer: t('faqPage.answers.workingHours')
    },
    {
      question: t('faqPage.questions.insuranceDMS'),
      answer: t('faqPage.answers.insuranceDMS')
    },
    {
      question: t('faqPage.questions.costOfAppointment'),
      answer: t('faqPage.answers.costOfAppointment')
    },
    {
      question: t('faqPage.questions.sickLeave'),
      answer: t('faqPage.answers.sickLeave')
    },
    {
      question: t('faqPage.questions.closeSickLeaveElsewhere'),
      answer: t('faqPage.answers.closeSickLeaveElsewhere')
    },
    {
      question: t('faqPage.questions.walkIn'),
      answer: t('faqPage.answers.walkIn')
    },
    {
      question: t('faqPage.questions.specialists'),
      answer: t('faqPage.answers.specialists')
    },
    {
      question: t('faqPage.questions.mriTypes'),
      answer: t('faqPage.answers.mriTypes')
    },
    {
      question: t('faqPage.questions.driverLicenseRequirements'),
      answer: t('faqPage.answers.driverLicenseRequirements')
    },
    {
      question: t('faqPage.questions.medicalExamDocuments'),
      answer: t('faqPage.answers.medicalExamDocuments')
    },
    {
      question: t('faqPage.questions.yakovlevSchedule'),
      answer: t('faqPage.answers.yakovlevSchedule')
    },
    {
      question: t('faqPage.questions.bloodTestTime'),
      answer: t('faqPage.answers.bloodTestTime')
    },
    {
      question: t('faqPage.questions.documentsFirstVisit'),
      answer: t('faqPage.answers.documentsFirstVisit')
    }
  ];

  return (
    <div className="faq-page">
      {/* Заголовок */}
      <div className="faq-header">
        <div className="section-divider">
          <h2>{t('faqPage.title')}</h2>
          <p className="faq-subtitle">{t('faqPage.subtitle')}</p>
        </div>
      </div>

      {/* Список вопросов */}
      <div className="faq-list-container">
        <div className="faq-list">
          {faqData.map((item, index) => (
            <div key={index} className="faq-item">
              <div className="faq-question">
                <span className="question-number">{index + 1}.</span>
                <span className="question-text">{item.question}</span>
              </div>
              <div className="faq-answer">
                {item.answer}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Кнопка назад внизу */}
      <div className="faq-footer">
        <button className="service-btn back-btn" onClick={onBack}>
          <span className="btn-icon">←</span>
          <span className="btn-text">{t('faqPage.backButton')}</span>
        </button>
      </div>
    </div>
  );
};

export default FaqPage;